import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.833 19.833h2.333v-7h-2.333zM14 10.5q.495 0 .83-.336.337-.335.336-.831 0-.496-.335-.831A1.13 1.13 0 0 0 14 8.166q-.495 0-.832.336-.335.335-.335.831t.335.831.832.336m0 15.166a11.4 11.4 0 0 1-4.55-.918 11.8 11.8 0 0 1-3.704-2.494 11.8 11.8 0 0 1-2.494-3.704A11.4 11.4 0 0 1 2.333 14q0-2.42.919-4.55a11.8 11.8 0 0 1 2.494-3.704A11.8 11.8 0 0 1 9.45 3.252 11.4 11.4 0 0 1 14 2.333q2.42 0 4.55.919a11.8 11.8 0 0 1 3.704 2.494 11.8 11.8 0 0 1 2.494 3.704 11.4 11.4 0 0 1 .918 4.55q0 2.42-.918 4.55a11.8 11.8 0 0 1-2.494 3.704 11.8 11.8 0 0 1-3.704 2.494 11.4 11.4 0 0 1-4.55.918m0-2.333q3.908 0 6.62-2.712T23.334 14t-2.712-6.621T14 4.666 7.379 7.38t-2.713 6.62T7.38 20.62t6.62 2.713" }, null, -1)
  ])))
}
export default { render: render }